import type { ColumnsType } from "antd/es/table";
import type { ImageCapturePage } from "@rumble-it/common-lib/types/models/ImageCapture.interface";
import { Button } from "@rumbledirect/ui";
import { Space } from "antd";
import { Link } from "react-router-dom";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";

export const imageCapturePageColumns = (
  imageCaptureId: string | undefined,
): ColumnsType<ImageCapturePage> => [
  {
    title: "Titel",
    dataIndex: "title",
    key: "title",
    render: (text, record) => (
      <Link to={`/image-captures/${imageCaptureId}/pages/${record.id}`}>
        {text}
      </Link>
    ),
  },
  {
    title: "Type",
    key: "type",
    render: (_, record) => record?.type?.name ?? record?.type?.value ?? "",
  },
  {
    title: "Volgorde",
    dataIndex: "priority",
    key: "priority",
  },
  {
    title: "Acties",
    key: "actions",
    align: "right",
    render: (_, record) => (
      <Space>
        <Link to={`/image-captures/${imageCaptureId}/pages/${record.id}`}>
          <Button icon={<EyeOutlined />} variant="light" />
        </Link>
        <Link to={`/image-captures/${imageCaptureId}/pages/${record.id}/edit`}>
          <Button icon={<EditOutlined />} variant="light" />
        </Link>
      </Space>
    ),
  },
];
